import { isTabletUp } from '../../scripts/helpers';

class Courses {
  constructor() {

    if(document.querySelector('.courses') != null && document.querySelector('.courses') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {
    var cardCarouselCourses = document.querySelectorAll('.card__carousel--courses');

    if(typeof(cardCarouselCourses) != 'undefined' && cardCarouselCourses != null) {
      if(!isTabletUp()) {
        $('.card__carousel--courses').slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1380,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
            }
          ]
        });
      }
    }

      
  }

}

$(document).ready(function() {
  const courses = new Courses();
});
